const PAYMENT_GATEWAY_CONSTS = {
    PAYMENT_STATUS: [
        'PENDING',
        'RECEIVED',
        'CONFIRMED',
        'OVERDUE',
        'REFUNDED',
        'RECEIVED_IN_CASH',
        'REFUND_REQUESTED',
        'CHARGEBACK_REQUESTED',
        'CHARGEBACK_DISPUTE',
        'AWAITING_CHARGEBACK_REVERSAL',
        'DUNNING_REQUESTED',
        'DUNNING_RECEIVED',
        'AWAITING_RISK_ANALYSIS'
    ],
    
    PAYMENT_METHODS: [
      {
        value: 'CREDIT_CARD',
        name: 'Cartão de crédito'
      },
      {
        value: 'BOLETO',
        name: 'Boleto'
      },
      {
        value: 'PIX',
        name: 'PIX'
      },
      {
        value: 'TRANSFER',
        name: 'Transferência bancária'
      },
      {
        value: 'DEPOSIT',
        name: 'Depósito bancário'
      },
      {
        value: 'UNDEFINED',
        name: 'Perguntar ao cliente'
      }
    ],

    PENDING_PAYMENT_STATUS: 'PENDING',

    SUCCESS_PAYMENT_STATUSES: ['CONFIRMED', 'RECEIVED', 'RECEIVED_IN_CASH', 'DUNNING_RECEIVED'],
    WARNING_PAYMENT_STATUSES: ['PENDING', 'REFUND_REQUESTED', 'CHARGEBACK_REQUESTED', 'CHARGEBACK_DISPUTE', 'AWAITING_CHARGEBACK_REVERSAL', 'DUNNING_REQUESTED', 'AWAITING_RISK_ANALYSIS'],
    ERROR_PAYMENT_STATUSES: ['OVERDUE']
}

export default PAYMENT_GATEWAY_CONSTS 